import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {

  
  customize: boolean = true;
  expand: boolean = false;

  constructor( ) {

  }

  ngOnInit(): void {
  }



  expandNav(){
    this.expand = !this.expand
  }

  navItems = [
    {
      id: '0',
      name : 'Admin',
      items :[
        {
          name: 'Users',
          link: '/users/usersList',
        },
        {
          name: 'Permissions',
          link: '/permissions/permissionList',
        },
        {
          name: 'Roles',
          link: '/roles/roleList',
        },
        {
          name: 'Organization',
          link: '/organization/organizationList',
        },
        {
          name: 'Module',
          link: '/moduleMaster/moduleList',
        }
      ]
    }
  ];  

}


